export default __webpack_public_path__ + "static/media/A11Y_Collab_3DSpatialAudio.3ece62cf.png";